import SVGIconWrapper from "./SVGIconWrapper"

const IconCheckmark = (props) => (
    <SVGIconWrapper
        fill={props.fill ?? "#000000"}
        style={props.style}
        viewBox="0 0 54.2 38.2"
        iconClass={`icon--checkmark ${props.iconClass}`}
        wrapperClass={props.wrapperClass}
        onClick={props.onClick}
    >
        <path d="M18,38.2L18,38.2c-0.5,0-1-0.2-1.4-0.6l-16-16.1c-0.8-0.8-0.8-2.1,0-2.8c0.8-0.8,2.1-0.8,2.8,0L18,33.4 L50.8,0.6c0.8-0.8,2-0.8,2.8,0s0.8,2,0,2.8L19.4,37.6C19,38,18.5,38.2,18,38.2z" />
    </SVGIconWrapper>
)

export default IconCheckmark